import styled from "styled-components";


export interface TypographyElementProps {
    size?: "smaller" | "small" | "medium" | "large" | "larger" | "x-large" | "xx-large" | "xxx-large",
    block?: boolean,
}

export const TypographyElement = styled.div<TypographyElementProps>`
    ${props => props.size?.length ? `font-size: ${props.size};` : '' }
    display: ${props => props.block ? 'block' : 'inline'};
`;